
import {
  BackupRepoDto,
  BackupRepoSecretsDto,
} from '@/services/Backup/interfaces/index';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackupDetailsDialog extends Vue {
  @Prop()
  public readonly backupRepo!: BackupRepoDto | BackupRepoSecretsDto;

  public visible: boolean = true;

  public configVisible: boolean = false;
  public selectedConfig: unknown = null;

  public destroyComponent(): void {
    this.$emit('close');
  }

  public showConfig(config: unknown): void {
    this.selectedConfig = config;
    this.configVisible = true;
  }
}
